/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Routes } from '@angular/router';

import {CurrentComponent} from "../current.component";
import {UsersComponent} from "../users.component";
import {StatsComponent} from "../stats.component";
import {OptionsComponent} from "../options.component";
import {PackagesComponent} from "../packages.component";
import {SelectorComponent} from "../selector.component";
import {LicenseComponent} from "../license.component";
import {HistoricalComponent} from "../historical.component";
import {UnavailableService} from "../services/unavailable-service";
import {NodeJSVersionComponent} from "../nodejs/version/version.component";
import {NodeJSApplicationComponent} from "../nodejs/application/application.component";


export const ROUTES: Routes = [
    { path: '',      component: CurrentComponent, canActivate: [UnavailableService] },
    { path: 'current', component: CurrentComponent, canActivate: [UnavailableService]},
    { path: 'users', component: UsersComponent, canActivate: [UnavailableService]},
    { path: 'stats', component: StatsComponent, canActivate: [UnavailableService]},
    {
        path: 'options', component: OptionsComponent, canActivate: [UnavailableService],
        children: [
            {path: 'versions', component: NodeJSVersionComponent, outlet: 'nodejs'},
            {path: 'applications/:id', component: NodeJSApplicationComponent, outlet: 'nodejs'},
        ],
    },
    { path: 'packages', component: PackagesComponent, canActivate: [UnavailableService]},
    { path: 'selector', component: SelectorComponent, canActivate: [UnavailableService]},
    { path: 'license', component: LicenseComponent, canActivate: [UnavailableService]},
    { path: 'historical', component: HistoricalComponent, canActivate: [UnavailableService]},
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/core/app.routes.ts